import { render } from "./esco-configuracao-equipe.vue?vue&type=template&id=b7b80df8&scoped=true"
import script from "./esco-configuracao-equipe.vue?vue&type=script&lang=js"
export * from "./esco-configuracao-equipe.vue?vue&type=script&lang=js"

import "./esco-configuracao-equipe.vue?vue&type=style&index=0&id=b7b80df8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b80df8"]])

export default __exports__